/**
 * WHICH SIDE OF THE DESK YOU ARE ON: RENTALS OR REPAIR.
 *
 * Anthony, 2026-09-28: "rv rental on one side of their crm, rv repair on
 * the other, in one dash with a button to swap between the two".
 *
 * WHO HAS TWO SIDES. A trade whose intake conversation is a rental
 * (intakeKind in trade.ts, which is 'rv' today). Asked through intakeKind
 * rather than by comparing the trade to "rv", for the reason trade.ts
 * gives: a second rental trade is a row in the vocabulary, not a hunt
 * through the screens for `=== "rv"`. Every other trade has one side,
 * Repair, and sees exactly the desk it had before this file existed.
 *
 * RENTALS BY DEFAULT for a trade that has both, because that is the
 * business: WeRV is a rental yard that also fixes RVs, not the other way
 * round. The choice is remembered per browser (src/ui/side.ts), the same
 * way the theme is, because it is about which job the person at this
 * screen is doing, and the same owner flips between the two all day.
 *
 * Pure, so the rule is tested without a browser.
 */

import { intakeKind } from "./trade.ts";

export type Side = "rentals" | "repair";

export const hasRentals = (trade: string | null | undefined): boolean => intakeKind(trade) === "rental";

/** The side to draw, from the trade and whatever this browser remembered. */
export function sideOf(trade: string | null | undefined, remembered: string | null | undefined): Side {
  if (!hasRentals(trade)) return "repair";
  return remembered === "repair" ? "repair" : "rentals";
}

/** Where each side's home is. Switching goes there, so the screen you land on belongs to the side you chose. */
export const SIDE_HOME: Record<Side, string> = { rentals: "#/", repair: "#/" };
